// Links in message text: `http(s)://…` and `www.…` runs become clickable. Punctuation that
// ends a sentence, and a closing bracket the link didn't open, stay out of the link.

export type LinkPart = { text: string; href?: string }

const URL_RE = /\b(?:https?:\/\/|www\.)[^\s<>"]+/gi

function trim(url: string): string {
  for (;;) {
    const last = url.at(-1) ?? ''
    if (/[.,;:!?'*_~]/.test(last)) url = url.slice(0, -1)
    else if (last === ')' && url.split('(').length < url.split(')').length) url = url.slice(0, -1)
    else if (last === ']' && url.split('[').length < url.split(']').length) url = url.slice(0, -1)
    else return url
  }
}

/** Splits text into plain runs and links (with the address to open). */
export function splitLinks(text: string): LinkPart[] {
  const out: LinkPart[] = []
  let at = 0
  for (const m of text.matchAll(URL_RE)) {
    const url = trim(m[0])
    if (url.length < 5 || url.toLowerCase() === 'www.' || /^https?:\/\/$/i.test(url)) continue
    if (m.index > at) out.push({ text: text.slice(at, m.index) })
    out.push({ text: url, href: /^https?:/i.test(url) ? url : `https://${url}` })
    at = m.index + url.length
  }
  if (at < text.length || !out.length) out.push({ text: text.slice(at) })
  return out
}
